import { motion } from "framer-motion";

import { Logo } from "../ui-custom/Logo";

export function SplashScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background/90">
      <div className="relative w-32 h-32 flex items-center justify-center">
        {/* Outer Ring - Thicker */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0.2, 0.5, 0.2],
            rotate: 360,
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: 3,
            ease: "linear",
            repeat: Infinity,
          }}
          className="absolute inset-0 border-4 border-primary/30 rounded-2xl"
        />

        {/* Inner Ring - Thinner */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0.3, 0.7, 0.3],
            rotate: -360,
            scale: [0.8, 1, 0.8],
          }}
          transition={{
            duration: 3,
            ease: "linear",
            repeat: Infinity,
          }}
          className="absolute inset-0 border-2 border-primary/50 rounded-2xl"
        />

        {/* Logo Container */}
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.5,
            ease: "easeOut",
          }}
          className="relative z-10"
        >
          <Logo
            variant="condensed"
            className="absolute top-0 left-0 w-full h-full flex items-center justify-center"
          />
        </motion.div>
      </div>
    </div>
  );
}
